var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen flex flex-col"},[_c('div',{staticClass:"flex-grow bg-secondary-500"},[_c('the-header'),_c('router-view')],1),_c('the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }